import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInfoCircle,
  faSyncAlt,
  faUserFriends,
  faHandshake,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import DonutChart from "./DonutChart";
import UserStatusChart from "./UserStatusChart";
import bannerImg from "../../assets/images/undraw_onboarding_o8mv.svg";
import { handlingApi } from "units/handlingApi";
import Cookies from "js-cookie";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    totalUsers: 0,
    deletedUsers: 0,
    totalRevenue: 0,
    usersPerPlan: {
      Basic: 0,
      Standard: 0,
      Premium: 0,
      Enterprise: 0,
      Single: 0,
    },
  });
  const adminToken = Cookies.get("adminToken");

  const navigate = useNavigate();
  const usersPerPlan =
    stats.usersPerPlan.Basic +
    stats.usersPerPlan.Enterprise +
    stats.usersPerPlan.Premium +
    stats.usersPerPlan.Standard +
    stats.usersPerPlan.Single;

  useEffect(() => {
    const fetchStats = async () => {
      if (!adminToken) {
        navigate("/admin/login");
        return;
      }

      try {
        const url = `${process.env.REACT_APP_API_BASE_URL}admin/dashboard-stats`;

        const res = await handlingApi({ url, method: "GET", data: {} , token: adminToken});

        if (res.statusCode === 200) {
          setStats(res.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchStats();
  }, []);

  return (
    <>
      <div className="main-content">
        <div className="dashboard-content">
          <div className="row align-items-center">
            {/* Welcome Banner */}
            <div className="col-md-6">
              <div className="welcome-banner p-4 bg-white rounded-lg d-flex align-items-center">
                <div className="welcome-text flex-grow-1 pr-3">
                  <h2 className="mb-3 font-weight-bold">
                    Welcome back, Admin!
                  </h2>
                  <p className="mb-0 text-muted">
                    Here's an overview of your Legal Bot performance at a
                    glance.
                  </p>
                </div>
                <div className="welcome-image">
                  <img
                    src={bannerImg}
                    alt="Dashboard illustration"
                    className="img-fluid rounded-lg"
                  />
                </div>
              </div>
            </div>

            {/* Revenue Card */}
            {/* <div className="col-md-6">
              <div className="right-panel">
                <div
                  className=""
                  style={{
                    borderLeft: "4px solid #28a745",
                    backgroundColor: "#fff",
                  }}
                >
                  <div className="card-body">
                    <div className="d-flex justify-content-between mb-2 align-items-center">
                      <h5 className="card-title mb-0 font-weight-bold text-dark">
                        Total Revenue
                      </h5>
                      <FontAwesomeIcon
                        icon={faInfoCircle}
                        size="lg"
                        className="text-muted"
                      />
                    </div>
                    <div className="mt-3">
                      <h2 className="display-4 font-weight-bold text-success">
                        {Number(stats.totalRevenue).toFixed(2)}€
                      </h2>
                      <p className="mb-0 text-secondary">Revenue generated</p>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>

          <div className="row stats-row">
            <div className="col-md-4">
              <div className="stat-card">
                <div className="stat-content">
                  <span className="stat-title">Total Users</span>
                  <h2 className="stat-value">{stats.totalUsers}</h2>
                </div>
                <div className="stat-icon bg-light-green">
                  <FontAwesomeIcon icon={faUsers} className="text-success" />
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="stat-card">
                <div className="stat-content">
                  <span className="stat-title">Active Users</span>
                  <h2 className="stat-value">
                    {stats.totalUsers - stats.deletedUsers}
                  </h2>
                </div>
                <div className="stat-icon bg-dark-blue">
                  <FontAwesomeIcon icon={faUsers} className="text-white" />
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="stat-card">
                <div className="stat-content">
                  <span className="stat-title">Deleted Users</span>
                  <h2 className="stat-value">{stats.deletedUsers}</h2>
                </div>
                <div className="stat-icon bg-red">
                  <FontAwesomeIcon
                    icon={faUserFriends}
                    className="text-white"
                  />
                </div>
              </div>
            </div>
            {/* <div className="col-md-3">
              <div className="stat-card">
                <div className="stat-content">
                  <span className="stat-title">Enterprise Users</span>
                  <h2 className="stat-value">
                    {stats.usersPerPlan.Enterprise}
                  </h2>
                </div>
                <div className="stat-icon bg-light-blue">
                  <FontAwesomeIcon icon={faHandshake} className="text-info" />
                </div>
              </div>
            </div> */}
          </div>

          <div className="row charts-row">
            {/* Chart 1: User Status (Active vs Deleted) */}
            <div className="col-12">
              <div className="chart-card">
                <div className="chart-header">
                  <span className="chart-title">User Status</span>
                  <FontAwesomeIcon icon={faSyncAlt} />
                </div>
                <div className="chart-body">
                  <UserStatusChart
                    totalUsers={stats.totalUsers}
                    deletedUsers={stats.deletedUsers}
                  />
                </div>
              </div>
            </div>
            {/* Chart 2: Plan Buys */}
            {/* <div className="col-md-6">
              <div className="chart-card">
                <div className="chart-header">
                  <span className="chart-title">
                    Plan Buys: ({usersPerPlan})
                  </span>
                  <FontAwesomeIcon icon={faSyncAlt} />
                </div>
                <div className="chart-body donut-chart-container">
                  <DonutChart usersPerPlan={stats.usersPerPlan} />
                </div>
              </div>
            </div> */}
          </div>

          {/* Plan Distribution Breakdown Section */}
          {/* <div className="row">
            <div className="col-md-12">
              <div className="plan-breakdown-card p-4 bg-white rounded-lg shadow-sm mt-4">
                <h5 className="mb-4 font-weight-bold">
                  Plan Distribution Breakdown
                </h5>

                <div className="plan-item mb-3">
                  <div className="d-flex justify-content-between mb-2">
                    <span>Basic</span>
                    <span>{stats.usersPerPlan.Basic}</span>
                  </div>
                  <div className="progress">
                    <div
                      className="progress-bar bg-info"
                      role="progressbar"
                      style={{
                        width: `${
                          usersPerPlan
                            ? (stats.usersPerPlan.Basic / usersPerPlan) * 100
                            : 0
                        }%`,
                      }}
                      aria-valuenow={stats.usersPerPlan.Basic}
                      aria-valuemin="0"
                      aria-valuemax={usersPerPlan}
                    ></div>
                  </div>
                </div>

                <div className="plan-item mb-3">
                  <div className="d-flex justify-content-between mb-2">
                    <span>Standard</span>
                    <span>{stats.usersPerPlan.Standard}</span>
                  </div>
                  <div className="progress">
                    <div
                      className="progress-bar bg-success"
                      role="progressbar"
                      style={{
                        width: `${
                          usersPerPlan
                            ? (stats.usersPerPlan.Standard / usersPerPlan) * 100
                            : 0
                        }%`,
                      }}
                      aria-valuenow={stats.usersPerPlan.Standard}
                      aria-valuemin="0"
                      aria-valuemax={usersPerPlan}
                    ></div>
                  </div>
                </div>

                <div className="plan-item mb-3">
                  <div className="d-flex justify-content-between mb-2">
                    <span>Premium</span>
                    <span>{stats.usersPerPlan.Premium}</span>
                  </div>
                  <div className="progress">
                    <div
                      className="progress-bar bg-warning"
                      role="progressbar"
                      style={{
                        width: `${
                          usersPerPlan
                            ? (stats.usersPerPlan.Premium / usersPerPlan) * 100
                            : 0
                        }%`,
                      }}
                      aria-valuenow={stats.usersPerPlan.Premium}
                      aria-valuemin="0"
                      aria-valuemax={usersPerPlan}
                    ></div>
                  </div>
                </div>

                <div className="plan-item mb-3">
                  <div className="d-flex justify-content-between mb-2">
                    <span>Enterprise</span>
                    <span>{stats.usersPerPlan.Enterprise}</span>
                  </div>
                  <div className="progress">
                    <div
                      className="progress-bar bg-danger"
                      role="progressbar"
                      style={{
                        width: `${
                          usersPerPlan
                            ? (stats.usersPerPlan.Enterprise / usersPerPlan) *
                              100
                            : 0
                        }%`,
                      }}
                      aria-valuenow={stats.usersPerPlan.Enterprise}
                      aria-valuemin="0"
                      aria-valuemax={usersPerPlan}
                    ></div>
                  </div>
                </div>

                <div className="plan-item">
                  <div className="d-flex justify-content-between mb-2">
                    <span>Single</span>
                    <span>{stats.usersPerPlan.Single}</span>
                  </div>
                  <div className="progress">
                    <div
                      className="progress-bar bg-secondary"
                      role="progressbar"
                      style={{
                        width: `${
                          usersPerPlan
                            ? (stats.usersPerPlan.Single / usersPerPlan) * 100
                            : 0
                        }%`,
                      }}
                      aria-valuenow={stats.usersPerPlan.Single}
                      aria-valuemin="0"
                      aria-valuemax={usersPerPlan}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;
